export default __webpack_public_path__ + "static/media/logo-claro-vacunate.673d6e96.png";